import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";

import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";

import DownloadApp from "components/cta/DownloadApp.js";

import Footer from "components/footers/MiniCenteredFooter.js";

import chefIconImageSrc from "images/chef-icon.svg";
import celebrationIconImageSrc from "images/celebration-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";
import { useState } from "react";
import client from "helpers/sanity";
import { useEffect } from "react";
import { categoriesQuery, singleDiet } from "constants/queries";

const Subheading = tw.span`tracking-wider text-sm font-medium`;
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
const Description = tw.span`inline-block mt-8`;
const imageCss = tw`rounded-4xl`;

export default () => {
  const [heroDiet, setHeroDiet] = useState(null);
  const [menu, setMenu] = useState({
    activeCategory: '',
    categories: [],
  })

  useEffect(() => {
    // 22e30e96-b5a4-49ba-ba24-16018310c7ce
    client.fetch(singleDiet, { id: ' 22e30e96-b5a4-49ba-ba24-16018310c7ce' }).then((data) => {
      setHeroDiet(data)
    });
  }, [])

  useEffect(() => {
    client.fetch(categoriesQuery(4)).then((data) => {
      setMenu((prev) => ({ ...prev, activeCategory: data[0].title, categories: data }))
    });
  }, []);

  return (
    <AnimationRevealPage>
      <Hero
        data={heroDiet}
        heading={
          <>
            Delicious & Affordable
            <HighlightedText>Meals Plans You.</HighlightedText>
          </>
        }
        description="Discover a wide variety of mouth-watering dishes that won’t break the bank. Whether you’re craving comfort food, exotic flavors, or healthy options, we’ve got you covered. Explore the best local eateries and enjoy meals that are both tasty and budget-friendly."
        imageSrc="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="View Now"
        watchVideoButtonText="Meet The nutritionist "
      />
      <MainFeature
        subheading={<Subheading>Established Since 2014</Subheading>}
        heading={
          <>
            We've been serving for
            <wbr /> <HighlightedText>over 5 years.</HighlightedText>
          </>
        }
        description={
          <Description>
            With a passion for quality and a commitment to excellence, we’ve been delighting customers with our exceptional service and delicious offerings.
            <br />
            <br />
            Our experience ensures that every meal is crafted with care, bringing you the best flavors and unforgettable dining experiences.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Latest Offers"
        imageSrc={
          "https://images.unsplash.com/photo-1460306855393-0410f61241c7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />

      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      <TabGrid
        tabs={menu.categories}
        handleTab={(tab) => setMenu({ ...menu, activeCategory: tab })}
        activeTab={menu.activeCategory}
        heading={
          <>
            Checkout our <HighlightedText>Diet Plans</HighlightedText>
          </>
        }
      />
      <Features
        heading={
          <>
            Amazing <HighlightedText>Services.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Explore our wide network of restaurants and enjoy delicious meals wherever you are.",
            url: "#",
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional nutritionist",
            description: "Our skilled nutritionist craft every dish with passion, ensuring a delightful culinary experience.",
            url: "#",
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Make your celebrations special with our customized catering services for birthdays and events.",
            url: "#",
          },
        ]}
        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      <MainFeature2
        subheading={<Subheading>A Reputed Brand</Subheading>}
        heading={
          <>
            Why <HighlightedText>Choose Us ?</HighlightedText>
          </>
        }
        description="We are committed to delivering exceptional quality, unforgettable flavors, and outstanding service. With years of experience, a team of professional nutritionist, and a passion for culinary excellence, we ensure every meal is a delightful experience. Whether it’s a quick bite or a special celebration, we’re here to make every moment memorable."
        statistics={[
          {
            key: "Orders",
            value: "94000+",
          },
          {
            key: "Customers",
            value: "11000+",
          },
          {
            key: "nutritionist",
            value: "1500+",
          },
        ]}
        primaryButtonText="Check Now"
        primaryButtonUrl="#"
        imageInsideDiv={false}
        imageSrc="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEzNzI2fQ&auto=format&fit=crop&w=768&q=80"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />
      <Testimonial
        subheading=""
        heading={
          <>
            Customers <HighlightedText>Love Us.</HighlightedText>
          </>
        }
      />
      <DownloadApp
        text={
          <>
            People around you are ordering delicious meals using the{" "}
            <HighlightedTextInverse>Help Yourself Goals App.</HighlightedTextInverse>
          </>
        }
      />
      <Footer />
    </AnimationRevealPage>
  );
};
